import { CameraOutlined } from "@ant-design/icons";
import { Button, Col, Form, Input, Row, Upload } from "antd";
import {
  RcFile,
  UploadChangeParam,
  UploadFile,
} from "antd/lib/upload/interface";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ButtonProps } from "../../helpers/constants";
import { authTokenString, baseURL } from "../../hooks/useAxiosPost";
import useMultiNotification from "../../hooks/useNotification";
import NetwalaButton from "../Items/Button/Index";
import PlusIcon from "./../../assets/svgs/IconsWhite/PlusIcon.svg";
const { TextArea } = Input;

const CreateISPForm = () => {
  const { openNotification, contextHolder } = useMultiNotification();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const onFinish = (values: any) => {
    handleCreateISP(values);
  };
  const [profilePictureList, setProfilePictureList] = useState<UploadFile[]>(
    []
  );

  const handleRemoveProfile = (file: UploadFile) => {
    setProfilePictureList((prevList) =>
      prevList.filter((item) => item.uid !== file.uid)
    );
  };

  const handleBeforeUploadProfile = (file: RcFile, fileList: RcFile[]) => {
    setProfilePictureList(
      fileList.map((file) => ({
        uid: file.uid,
        name: file.name,
        status: "done",
      }))
    );
    // You can add your upload logic here if needed
    return false; // Return false here to avoid auto uploading
  };

  const handleChangeProfile = (info: UploadChangeParam) => {
    setProfilePictureList(info.fileList);
  };

  const onFinishFailed = (errorInfo: any) => {};

  const handleCreateISP = async (values: any) => {
    setIsLoading(true);
    const formData = new FormData();
    formData.append("authTokenString", authTokenString.toString());
    formData.append("ISPName", values.ISPName);
    formData.append("ISPSalesEmail", values.ISPSalesEmail);
    formData.append("ISPSupportEmail", values.ISPSupportEmail);
    formData.append("ISPSupportNumber", values.ISPSupportNumber);
    formData.append("IspSalesNumber", values.IspSalesNumber);

    if (profilePictureList.length > 0) {
      formData.append("ispLogo", profilePictureList[0].originFileObj as Blob);
    }
    try {
      const response = await fetch(`${baseURL}/isps/createNewISP`, {
        method: "POST",
        body: formData,
        // Note: When using FormData, do NOT set the Content-Type header
        // The browser will set it automatically, including the boundary parameter
      });

      if (response.ok) {
        const responseData = await response.json();
        openNotification(
          "success",
          "Success",
          responseData?.message || "ISP Created Successfully"
        );
        setTimeout(() => {
          navigate(`/isps`);
        }, 3000);
      } else {
        const responseData = await response.json();
        setIsLoading(false);
        openNotification(
          "error",
          "Operation Failed",
          responseData?.message || "Server Error"
        );
        console.error("Upload failed:", responseData);
      }
    } catch (error) {
      setIsLoading(false);

      console.error("Error during fetch:", error);
    }
  };
  //   ISPName, ISPSupportNumber, ISPSupportEmail, ISPSalesEmail,
  return (
    <>
      {contextHolder}

      <Row style={{ width: "100%" }}>
        <Form
          name="createIspForm"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          layout="vertical"
          requiredMark={false}
          style={{ width: "100%" }}
          form={form}
        >
          {/* First */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">ISP Name</span>}
                name="ISPName"
                getValueFromEvent={(e) => e.target.value.trimStart()} // trims start spaces as user types
                rules={[
                  {
                    required: true,
                    message: "Please enter ISP Name",
                  },
                  {
                    pattern: /^[a-zA-Z0-9._-]+$/,
                    message:
                      "ISP Name can only contain letters, numbers, period (.), underscore (_), and hyphen (-)",
                  },
                  {
                    validator: (_, value) => {
                      if (value && value.trim().length === 0) {
                        return Promise.reject(
                          "ISP Name cannot be empty or contain only spaces"
                        );
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="Transworld"
                  onBlur={(e) => {
                    e.target.value = e.target.value.trim(); // trim on blur
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
          {/* Second */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Support Email</span>
                }
                name="ISPSupportEmail"
                rules={[
                  {
                    required: true,
                    message: "Please enter Support Email",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid Support email address",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="support@xyz.com"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Sales Email</span>
                }
                name="ISPSalesEmail"
                rules={[
                  {
                    required: true,
                    message: "Please enter Sales Email",
                  },
                  {
                    type: "email",
                    message: "Please enter a valid Sale email address",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="sales@xyz.com"
                />
              </Form.Item>
            </Col>
          </Row>
          {/* Third */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Support Number</span>
                }
                name="ISPSupportNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter ISP Support Number",
                  },
                  {
                    pattern: /^(?:\+92|0)?3[0-9]{9}$/,
                    message: "Please enter a valid Pakistani phone number",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="03451234567"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={
                  <span className="create-user-form-label">Sales Number</span>
                }
                name="IspSalesNumber"
                rules={[
                  {
                    required: true,
                    message: "Please enter ISP Sales Number",
                  },
                  {
                    pattern: /^(?:\+92|0)?3[0-9]{9}$/,
                    message: "Please enter a valid Pakistani phone number",
                  },
                ]}
              >
                <Input
                  className="user-input-general-height"
                  placeholder="03451234567"
                />
              </Form.Item>
            </Col>
          </Row>

          {/* Fifth */}
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                label={<span className="create-user-form-label">ISP Logo</span>}
                name="userProfile"
                rules={[
                  {
                    required: true,
                    message: "Please upload an ISP logo!",
                    validator: (_, value) =>
                      profilePictureList.length > 0
                        ? Promise.resolve()
                        : Promise.reject(
                            new Error("Please upload an ISP logo!")
                          ),
                  },
                ]}
                valuePropName="fileList"
                getValueFromEvent={(e) => {
                  if (Array.isArray(e)) {
                    return e;
                  }
                  return e && e.fileList;
                }}
              >
                <Upload
                  onRemove={handleRemoveProfile}
                  beforeUpload={handleBeforeUploadProfile}
                  onChange={handleChangeProfile}
                  fileList={profilePictureList}
                >
                  <Button icon={<CameraOutlined />}>Upload Logo</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>

          {/* Create Button Row */}
          <Row>
            <Col
              style={{ display: "flex", justifyContent: "center" }}
              span={24}
            >
              <Form.Item>
                <NetwalaButton
                  htmlType="submit"
                  backgroundColor={ButtonProps.background.STANDARD}
                  height={ButtonProps.height.STANDARD}
                  width={ButtonProps.width.STANDARD}
                  textColor={ButtonProps.color.STANDARD}
                  onClick={() => {
                    console.log("clicked");
                  }}
                  text="Create ISP"
                  icon={<img src={PlusIcon} />}
                  disabled={isLoading}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Row>
    </>
  );
};
export default CreateISPForm;
